module.exports = __webpack_public_path__ + "static/img/guide-betting-method.e509a39.jpg";